import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { ReadingAidsPopupProps } from '../../types';

import { AIDefinitionsActionType } from './actions';
import { createCommand } from './plugin-factory';

export const updateKeywordDecorations = ({
	keywordDecorations,
}: {
	keywordDecorations: DecorationSet;
}) => {
	return createCommand((state: EditorState) => {
		return {
			type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS,
			keywordDecorations,
		};
	});
};

export const toggleReadingAidsPopup = (
	opts:
		| {
				open: true;
				readingAidsPopupProps: ReadingAidsPopupProps;
		  }
		| {
				open: false;
		  },
) => {
	return createCommand(() => {
		return {
			type: AIDefinitionsActionType.TOGGLE_READING_AIDS_POPUP,
			isReadingAidsPopupOpen: opts.open,
			readingAidsPopupProps: opts.open ? opts.readingAidsPopupProps : undefined,
		};
	});
};
